import { memo, FC } from 'react';
import { Tab } from 'Types';
import { TabNavigation } from 'Elements';
import styles from 'partials/decoration/page-decoration-box.module.scss';

interface Props {
	tabs: Tab[];
	isValid?: boolean;
	trigger?: () => void;
}

export const DecorationTab: FC<Props> = memo(({ tabs, isValid, trigger }) => {
	return (
		<div className={styles.tab}>
			{tabs?.map((tab) => {
				return (
					<TabNavigation
						key={tab.id}
						to={tab.path}
						title={tab.title}
						isActive={tab.isActive}
						isValid={isValid}
						trigger={trigger}
					/>
				);
			})}
		</div>
	);
});

DecorationTab.displayName = 'DecorationTab';
